import { createSelector } from 'reselect'
import slideDataSelector from 'redux/selectors/student/slide_data_selector'
import slideTypes from 'helpers/enums/slideTypes'

const getSlideData = (state, slideId) => slideDataSelector(state, slideId)

export default createSelector(
	[ getSlideData ],
	slideData => {
		switch (slideData.type) {
			case slideTypes.SLIDE_TYPE_ID_OPEN_ENDED_QUESTION:
				return 'Open Ended Question'
			case slideTypes.SLIDE_TYPE_ID_QUIZ:
				return 'Quiz'
			case slideTypes.SLIDE_TYPE_ID_DRAW_IT:
				return 'Draw It'
			case slideTypes.SLIDE_TYPE_ID_POLL:
				return 'Poll'
			case slideTypes.SLIDE_TYPE_ID_MATCHING_PAIRS:
				return 'Matching Pairs'
			case slideTypes.SLIDE_TYPE_ID_SLIDE:
				return 'Google Slide'
			default:
				return ''
		}
	}
)
